import { render, staticRenderFns } from "./OrganizationProfileStatusBanner.vue?vue&type=template&id=150780ee&"
import script from "./OrganizationProfileStatusBanner.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileStatusBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports